
export const environment = {
	production: true,
	sandboxApiUrl: 'https://hosts.morgan.salestabcentral.com/',
	brand: 'L',
	testUsername: '',
	testPassword: '',
	addressable_api: null,
	country: 'NZ',
	allowItemsWithNoDelivery: false,
	allowUnlinkedOptions: false,
	allowEditableDescriptions: false,
	surchargeEnabled: true,
};